var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5581 21.7336C22.366 18.5451 19.2918 16.275 15.6875 16.275C12.0832 16.275 9.00902 18.5451 7.8169 21.7336M23.5581 21.7336C26.0881 19.5335 27.6875 16.291 27.6875 12.675C27.6875 6.04757 22.3149 0.674988 15.6875 0.674988C9.06008 0.674988 3.6875 6.04757 3.6875 12.675C3.6875 16.291 5.28692 19.5335 7.8169 21.7336M23.5581 21.7336C21.4512 23.5658 18.6989 24.675 15.6875 24.675C12.6761 24.675 9.92383 23.5657 7.8169 21.7336",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(1 0 0 -1 12.6875 13.175)",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.675C0.223858 12.675 2.41411e-08 12.8988 0 13.175C-2.41411e-08 13.4511 0.223858 13.675 0.5 13.675L0.5 13.175L0.5 12.675ZM10.8536 13.5285C11.0488 13.3333 11.0488 13.0167 10.8536 12.8214L7.67157 9.63945C7.47631 9.44419 7.15973 9.44419 6.96447 9.63945C6.7692 9.83472 6.7692 10.1513 6.96447 10.3466L9.79289 13.175L6.96447 16.0034C6.7692 16.1987 6.7692 16.5153 6.96447 16.7105C7.15973 16.9058 7.47631 16.9058 7.67157 16.7105L10.8536 13.5285ZM0.5 13.175L0.5 13.675L10.5 13.675L10.5 13.175L10.5 12.675L0.5 12.675L0.5 13.175Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.9220830628b4c69896ba5e1ae66bc1e0.svg";
export { ForwardRef as ReactComponent };